import { render, staticRenderFns } from "./ValidationTag.vue?vue&type=template&id=07c6e774&scoped=true&"
import script from "./ValidationTag.vue?vue&type=script&lang=js&"
export * from "./ValidationTag.vue?vue&type=script&lang=js&"
import style0 from "./ValidationTag.vue?vue&type=style&index=0&id=07c6e774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c6e774",
  null
  
)

export default component.exports